import React, { useState, useEffect } from 'react';
import { ChevronDownIcon } from './Icons';
import './ScrollIndicator.css';

const ScrollIndicator = () => {
    const [opacity, setOpacity] = useState(1);

    useEffect(() => {
        const handleScroll = () => {
            const scrollY = window.scrollY;
            const threshold = 300; // Hide when scrolled past 300px
            const newOpacity = Math.max(0, 1 - scrollY / threshold);
            setOpacity(newOpacity);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const scrollToNext = () => {
        window.scrollTo({
            top: window.innerHeight * 0.9,
            behavior: 'smooth'
        });
    };

    if (opacity === 0) return null;

    return (
        <div
            className="global-scroll-indicator"
            onClick={scrollToNext}
            style={{ opacity }}
        >
            <div className="scroll-btn-container">
                <ChevronDownIcon />
                <div className="scroll-pulse-ring"></div>
            </div>
        </div>
    );
};

export default ScrollIndicator;
